export function isNumeric(str: string): boolean {
  return /^\d+$/.test(str);
}

export function capitalize(str: string): string {
  return (str && str[0].toUpperCase() + str.slice(1)) || '';
}

export function formatErrorMessage(input: string): string {
  return input.toLowerCase().replace(/_/g, ' ');
}

export const stringifyObjectValues = <T extends Record<string, unknown>>(input: T): Record<string, string> => {
  return Object.entries(input).reduce(
    (result, [key, value]) => {
      result[key] = typeof value === 'string' ? value : JSON.stringify(value);
      return result;
    },
    {} as Record<string, string>
  );
};

export const parseStringifiedValues = (input: Record<string, string>): Record<string, unknown> => {
  return Object.entries(input).reduce(
    (result, [key, value]) => {
      try {
        const lowerCaseValue = value.toLowerCase();
        if (lowerCaseValue === 'true' || lowerCaseValue === 'false') {
          result[key] = JSON.parse(lowerCaseValue);
        } else {
          result[key] = JSON.parse(value);
        }
      } catch {
        result[key] = value;
      }
      return result;
    },
    {} as Record<string, unknown>
  );
};
